import { useEffect } from "react";
import Login from "src/common/page/login";
import { useAuthStore } from "src/store";
import { useNavigate } from "react-router-dom";

let authed = false;

const Callback = (): JSX.Element => {
  const { loginText, errorText, setTokenAndProfile } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authed) {
      const params = new URLSearchParams(window.location.search);
      const data = Object.fromEntries(params);
      Object.assign(data, {
        callbackUrl: window.location.origin + "/callback",
      });
      setTokenAndProfile(data)
        .then(() => {
          const resume = sessionStorage.getItem("resume");
          if (resume) {
            sessionStorage.removeItem("resume");
            navigate(resume);
          } else {
            navigate("/");
          }
        })
        .catch((err) => console.error(err));
    }

    return () => {
      authed = true;
    };
  }, [setTokenAndProfile, navigate]);

  return <Login redirecting={loginText} error={errorText} />;
};

export default Callback;
